// extracted by mini-css-extract-plugin
export var divider = "_w8-0";